import { BaseResponse } from './_base';

export enum ICalType {
  AIRBNB = 'AIRBNB',
  BOOKING_COM = 'BOOKING_COM',
  VRBO = 'VRBO',
  TRIP_ADVISOR = 'TRIP_ADVISOR',
  DEFAULT = 'DEFAULT',
}

export interface ICal {
  uid?: string;
  name?: string | null;
  url: string;
  type: ICalType;
  propertyUid?: string | null;
  unitUid?: string | null;
}

export interface GetAllICalsResponse extends BaseResponse {
  icals: ICal[];
}
